import styled from 'styled-components'

export const Button = styled.button`
  outline-color: #002d63;
  padding: 12px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: #25a37b;
`

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
  border: 0;
  outline: none;
`

export const Text = styled.p`
  font-size: 16px;
  margin: 0;
`

export const Label = styled.label`
  margin: 0;
  text-align: center;
`

export const SubTitle = styled.h2`
  text-align: center;
`
